import { gql } from 'graphql-request';

export const algoliaHierarchicalMenuGql = gql`
  ... on AlgoliaHierarchicalmenuRecord {
    id
    widgetName: _modelApiKey
    collapseOpenDesktop
    collapseOpenMobile
    attributes: facets {
      attribute
    }
  }
`;

export const algoliaRangeInputGql = gql`
  ... on AlgoliaRangeinputRecord {
    id
    widgetName: _modelApiKey
    attribute {
      attribute
    }
    collapseOpenDesktop
    collapseOpenMobile
    enabledSlider
    attributeType
  }
`;

export const algoliaRatingMenuGql = gql`
  ... on AlgoliaRatingmenuRecord {
    id
    attribute {
      attribute
    }
    collapseOpenDesktop
    collapseOpenMobile
    widgetName: _modelApiKey
  }
`;

export const algoliaRefinementListGql = gql`
  ... on AlgoliaRefinementlistRecord {
    id
    widgetName: _modelApiKey
    attribute {
      attribute
    }
    collapseOpenDesktop
    collapseOpenMobile
  }
`;

export const algoliaRemoveFacetsGql = gql`
  ... on AlgoliaRemovefacetRecord {
    id
    widgetName: _modelApiKey
    attributes: facets {
      attribute
    }
  }
`;

export const algoliaToggleSectionGql = gql`
  ... on AlgoliaSectionToggleRecord {
    id
    widgetName: _modelApiKey
    facets {
      attribute {
        attribute
      }
      label
    }
    sectionLabel: label
    collapseOpenDesktop
    collapseOpenMobile
  }
`;

export const algoliaAutomaticFacetsGql = gql`
  ... on AlgoliaAutomaticRecord {
    id
    widgetName: _modelApiKey
    count
  }
`;

export const algoliaAllFiltersGql = gql`
  ${algoliaAutomaticFacetsGql}
  ${algoliaHierarchicalMenuGql}
  ${algoliaRangeInputGql}
  ${algoliaRatingMenuGql}
  ${algoliaRefinementListGql}
  ${algoliaRemoveFacetsGql}
  ${algoliaToggleSectionGql}
`;

export const algoliaFiltersGql = gql`
  categoryAlgoliaFilters {
    ${algoliaAllFiltersGql}
  }
`;
